import React, { useState, useEffect, useRef } from "react";
import "./App.css";
import TeslaGame from "./TeslaGame";

// Cloudflare Turnstile (anti-bot) — paste the public "Site Key" here once created
// in Cloudflare → Turnstile. Left empty, the widget is simply not shown.
const TURNSTILE_SITE_KEY = "0x4AAAAAAFfq5L99vioEIZ1m";

const STRIPE_PK = process.env.REACT_APP_STRIPE_PK || "pk_live_51Rg9tECKcaTcOU9mZUxHGwzw2NgO0Tu9XLUYnxJzty9jwGQ91cF7UKdOz7p9Xr5epG7xzhlr0uyTFgPWZwxJZPkV00C3NTqh6P";
const API_BASE  = "https://app02.azurewebsites.net/api";

// ── Translations ──────────────────────────────────────────────────────────────
const T = {
  en: {
    navWhy: "Why give?", navCrypto: "Crypto", navDonors: "Donors", navDonate: "Donate",
    heroEyebrow: "For those who have money",
    heroH1a: "One gift.", heroH1b: "One honest", heroH1c: "transaction.",
    heroSub: "No charity. No cause. No pretense. Just a person on the internet who built a place for surplus generosity to land.",
    heroCta: "Make a donation", heroLearn: "Learn more ↓",
    statDonors: "donors worldwide", statGiven: "Donations", statCountries: "countries",
    whyEyebrow: "The idea",
    whyH2a: "Some people simply", whyH2b: "don't know where", whyH2c: "to send their generosity.",
    whyP1: "This site was built for them. No designated cause, no emotional manipulation, no 90% overhead. Just a direct, honest place to give.",
    whyP2: "The money goes to me — the person who built this. That's the whole story. Simplicity in a world far too complicated.",
    card1Title: "Radically honest",      card1Desc: "No charity facade. The money goes to a real person. That's stated clearly, upfront, always.",
    card2Title: "Pure generosity",       card2Desc: "No rewards, no subscriptions, no hidden perks — just a simple act of support that can genuinely make a difference.",
    card3Title: "A small gesture, a real impact", card3Desc: "People from all around the world choose to contribute, proving that even a small donation from a stranger can mean something powerful.",
    donateEyebrow: "Make your move",
    donateH2a: "What will your", donateH2b: "one gift", donateH2c: "be today?",
    donateSub: "There is no wrong amount. There is no perfect reason to wait for. The only thing that matters is that today, you chose to give.",
    formTitle: "Your donation", formSub: "Choose an amount or enter your own",
    formName: "Your name or alias", formMsg: "Message (optional)",
    formMsgPh: "Why are you giving? (or don't explain — that's fine too)",
    formAnon: "Donate anonymously", formSecure: "🔒 Secured by Stripe · No account required",
    cryptoEyebrow: "On-chain", cryptoH2: "Prefer crypto?",
    cryptoSub: "Send directly to my wallet. No intermediary, no platform fees — just a pure on-chain transfer.",
    cryptoScan: "Scan with your wallet app", cryptoAccepts: "This address accepts",
    cryptoWarning: "Compatible with Base, Ethereum, Polygon, Arbitrum, BNB and all EVM chains. Sending from a non-EVM chain (Bitcoin, Solana) will result in permanent loss.",
    transpEyebrow: "Full transparency", transpH2: "Where does the money go?",
    transpSub: "Short answer: to me. Here's what that actually means.",
    t1Title: "Restaurants & pleasure", t1Desc: "Good food, good wine, good memories. A life well-lived deserves the occasional indulgence — and you're helping fund it.",
    t2Title: "My next big project",    t2Desc: "A Tesla. Yes, really. Every donation brings me one small step closer to driving in complete, electric, guilt-free silence.",
    t3Title: "The dream: my mortgage", t3Desc: "Owning a home outright. No monthly payment, no bank, just a roof that's truly mine. A man can dream — and apparently, so can you.",
    donorsEyebrow: "They gave", donorsH2: "Recent donors",
    donorsEmpty: "No donors yet.", donorsEmptySub: "Be the first — your name goes here.",
    manifestoQ: "There are people on this planet who are generous.", manifestoEm: "This was built for them.", manifestoEnd: "One honest gift. No drama. Just the quiet satisfaction of having done a truly good thing.",
    manifestoCite: "— The person behind 1-donation.com",
    footerDisclaimer: "Donations are voluntary and without any counterpart",
    footerCopy: "© 2026 1-donation.com",
    thankYouTitle: "Thank you.", thankYouP: "Genuinely. You just sent money to a stranger on the internet and asked for nothing in return.",
    thankYouEm: "That's kind of beautiful.", thankYouNote: "Your name will appear in the donors section shortly. A confirmation has been sent to your email by Stripe.",
    thankYouBtn: "Close — and thank you again",
    copyBtn: "Copy", copiedBtn: "Copied ✓", donateLoading: "Redirecting to Stripe…", donateCta: "Give", donateNow: "right now",
    amountSubs: ["A coffee","Two coffees","A nice meal","Why not","Very generous","Your call"],
    amountOther: "Other",
  },
  fr: {
    navWhy: "Pourquoi ?", navCrypto: "Crypto", navDonors: "Donateurs", navDonate: "Donner",
    heroEyebrow: "Pour ceux qui ont de l'argent",
    heroH1a: "Un seul don.", heroH1b: "Une transaction", heroH1c: "honnête.",
    heroSub: "Pas d'association. Pas de cause. Juste une personne qui a créé un endroit où la générosité peut atterrir.",
    heroCta: "Faire un don", heroLearn: "En savoir plus ↓",
    statDonors: "donateurs dans le monde", statGiven: "Dons", statCountries: "pays",
    whyEyebrow: "L'idée",
    whyH2a: "Certaines personnes", whyH2b: "ne savent pas où", whyH2c: "envoyer leur générosité.",
    whyP1: "Ce site a été créé pour elles. Pas de cause désignée, pas de manipulation. Juste un endroit direct et honnête pour donner.",
    whyP2: "L'argent va directement à moi — la personne qui a construit ceci. C'est toute l'histoire. La simplicité dans un monde bien trop compliqué.",
    card1Title: "Radicalement honnête",   card1Desc: "Pas de façade caritative. L'argent va à une vraie personne. C'est dit clairement, d'emblée, toujours.",
    card2Title: "Générosité pure",         card2Desc: "Pas de récompenses, pas d'abonnements — juste un simple acte de soutien qui peut vraiment faire la différence.",
    card3Title: "Un petit geste, un vrai impact", card3Desc: "Des gens du monde entier choisissent de contribuer, prouvant qu'un petit don d'un inconnu peut signifier quelque chose de puissant.",
    donateEyebrow: "Passez à l'acte",
    donateH2a: "Quel sera", donateH2b: "votre don", donateH2c: "aujourd'hui ?",
    donateSub: "Il n'y a pas de mauvais montant. Pas de bonne raison d'attendre. La seule chose qui compte, c'est qu'aujourd'hui vous avez choisi de donner.",
    formTitle: "Votre don", formSub: "Choisissez un montant ou entrez le vôtre",
    formName: "Votre prénom ou pseudo", formMsg: "Message (optionnel)",
    formMsgPh: "Pourquoi donnez-vous ? (ou ne l'expliquez pas — c'est très bien aussi)",
    formAnon: "Donner anonymement", formSecure: "🔒 Sécurisé par Stripe · Aucun compte requis",
    cryptoEyebrow: "On-chain", cryptoH2: "Vous préférez la crypto ?",
    cryptoSub: "Envoyez directement à mon portefeuille. Pas d'intermédiaire, pas de frais.",
    cryptoScan: "Scanner avec votre app", cryptoAccepts: "Cette adresse accepte",
    cryptoWarning: "Compatible avec Base, Ethereum, Polygon, Arbitrum, BNB. Envoyer depuis une chaîne non-EVM (Bitcoin, Solana) entraînera une perte permanente.",
    transpEyebrow: "Transparence totale", transpH2: "Où va l'argent ?",
    transpSub: "Réponse courte : à moi. Voici ce que ça signifie concrètement.",
    t1Title: "Restaurants & plaisirs", t1Desc: "Bonne nourriture, bon vin, beaux souvenirs. Une belle vie mérite ses plaisirs — et vous aidez à les financer.",
    t2Title: "Mon prochain grand projet", t2Desc: "Une Tesla. Oui, vraiment. Chaque don me rapproche un peu plus de conduire en silence électrique et sans culpabilité.",
    t3Title: "Le rêve : mon crédit", t3Desc: "Être propriétaire sans mensualités. Pas de banque, juste un toit vraiment à moi. On peut rêver — et apparemment, vous aussi.",
    donorsEyebrow: "Ils ont donné", donorsH2: "Derniers donateurs",
    donorsEmpty: "Pas encore de donateurs.", donorsEmptySub: "Soyez le premier — votre nom apparaîtra ici.",
    manifestoQ: "Il y a des gens sur cette planète qui sont généreux.", manifestoEm: "Ce site a été créé pour eux.", manifestoEnd: "Un don honnête. Sans drama. Juste la satisfaction tranquille d'avoir fait une réelle bonne action.",
    manifestoCite: "— La personne derrière 1-donation.com",
    footerDisclaimer: "Les dons sont volontaires et sans contrepartie",
    footerCopy: "© 2026 1-donation.com",
    thankYouTitle: "Merci.", thankYouP: "Sincèrement. Vous venez d'envoyer de l'argent à un inconnu sur internet sans rien demander en retour.",
    thankYouEm: "C'est assez beau.", thankYouNote: "Votre nom apparaîtra dans la section donateurs sous peu. Une confirmation a été envoyée à votre email par Stripe.",
    thankYouBtn: "Fermer — et merci encore",
    copyBtn: "Copier", copiedBtn: "Copié ✓", donateLoading: "Redirection vers Stripe…", donateCta: "Donner", donateNow: "maintenant",
    amountSubs: ["Un café","Deux cafés","Un bon repas","Pourquoi pas","Très généreux","Votre choix"],
    amountOther: "Autre",
  },
  ru: {
    navWhy: "Зачем?", navCrypto: "Крипто", navDonors: "Доноры", navDonate: "Донат",
    heroEyebrow: "Для тех, у кого есть деньги",
    heroH1a: "Один подарок.", heroH1b: "Одна честная", heroH1c: "транзакция.",
    heroSub: "Никаких организаций. Никаких причин. Просто человек, который создал место, куда может прийти ваша щедрость.",
    heroCta: "Сделать пожертвование", heroLearn: "Узнать больше ↓",
    statDonors: "доноров по миру", statGiven: "Пожертвования", statCountries: "стран",
    whyEyebrow: "Идея",
    whyH2a: "Некоторые люди просто", whyH2b: "не знают, куда", whyH2c: "направить щедрость.",
    whyP1: "Этот сайт создан для них. Никаких организаций, никаких накладных расходов. Просто честное место для пожертвований.",
    whyP2: "Деньги идут мне — человеку, который это создал. Вот и вся история. Простота в слишком сложном мире.",
    card1Title: "Абсолютная честность",  card1Desc: "Никакой благотворительной маски. Деньги идут реальному человеку. Это написано прямо, сразу, всегда.",
    card2Title: "Чистая щедрость",        card2Desc: "Никаких наград, никаких подписок — просто простой акт поддержки, который может иметь значение.",
    card3Title: "Маленький жест, реальный эффект", card3Desc: "Люди со всего мира делают взнос, доказывая, что даже небольшое пожертвование от незнакомца может многое значить.",
    donateEyebrow: "Сделайте шаг",
    donateH2a: "Каким будет ваш", donateH2b: "сегодняшний", donateH2c: "подарок?",
    donateSub: "Нет неправильной суммы. Нет причины ждать. Главное — что сегодня вы решили дать.",
    formTitle: "Ваш донат", formSub: "Выберите сумму или введите свою",
    formName: "Ваше имя или псевдоним", formMsg: "Сообщение (необязательно)",
    formMsgPh: "Почему вы даёте? (можно не объяснять — это тоже нормально)",
    formAnon: "Донатить анонимно", formSecure: "🔒 Защищено Stripe · Аккаунт не нужен",
    cryptoEyebrow: "On-chain", cryptoH2: "Предпочитаете крипто?",
    cryptoSub: "Отправьте прямо на мой кошелёк. Без посредников и комиссий платформы.",
    cryptoScan: "Сканируйте кошельком", cryptoAccepts: "Этот адрес принимает",
    cryptoWarning: "Совместимо с Base, Ethereum, Polygon, Arbitrum, BNB. Отправка с не-EVM сети (Bitcoin, Solana) приведёт к безвозвратной потере средств.",
    transpEyebrow: "Полная прозрачность", transpH2: "Куда идут деньги?",
    transpSub: "Короткий ответ: мне. Вот что это значит конкретно.",
    t1Title: "Рестораны и удовольствия", t1Desc: "Хорошая еда, хорошее вино, хорошие воспоминания. Красивая жизнь заслуживает маленьких радостей.",
    t2Title: "Мой следующий проект",     t2Desc: "Tesla. Да, серьёзно. Каждый донат приближает меня к езде в полной электрической тишине.",
    t3Title: "Мечта: ипотека",           t3Desc: "Владеть жильём без ежемесячных платежей. Без банка. Просто своя крыша. Можно мечтать — и вы тоже.",
    donorsEyebrow: "Они дали", donorsH2: "Последние доноры",
    donorsEmpty: "Пока нет доноров.", donorsEmptySub: "Будьте первым — ваше имя появится здесь.",
    manifestoQ: "На этой планете есть щедрые люди.", manifestoEm: "Этот сайт создан для них.", manifestoEnd: "Один честный подарок. Без драмы. Просто тихое удовлетворение от того, что совершил по-настоящему доброе дело.",
    manifestoCite: "— Человек за 1-donation.com",
    footerDisclaimer: "Пожертвования добровольны и без встречного предоставления",
    footerCopy: "© 2026 1-donation.com",
    thankYouTitle: "Спасибо.", thankYouP: "Искренне. Вы только что отправили деньги незнакомцу в интернете, не попросив ничего взамен.",
    thankYouEm: "Это по-своему красиво.", thankYouNote: "Ваше имя скоро появится в разделе доноров. Stripe отправил подтверждение на ваш email.",
    thankYouBtn: "Закрыть — и ещё раз спасибо",
    copyBtn: "Копировать", copiedBtn: "Скопировано ✓", donateLoading: "Перенаправление на Stripe…", donateCta: "Отправить", donateNow: "сейчас",
    amountSubs: ["Кофе","Два кофе","Хороший обед","Почему нет","Очень щедро","Ваш выбор"],
    amountOther: "Другое",
  },
  ja: {
    navWhy: "なぜ？", navCrypto: "暗号通貨", navDonors: "寄付者", navDonate: "寄付する",
    heroEyebrow: "お金の使い道を探している方へ",
    heroH1a: "一つの贈り物。", heroH1b: "一つの誠実な", heroH1c: "取引。",
    heroSub: "慈善団体なし。大義なし。ただ、余った善意の行き場を作ったインターネット上の一人の人間。",
    heroCta: "寄付をする", heroLearn: "もっと詳しく ↓",
    statDonors: "世界中の寄付者", statGiven: "寄付", statCountries: "カ国",
    whyEyebrow: "このアイデアについて",
    whyH2a: "一部の人々は", whyH2b: "どこに寄付すれば", whyH2c: "いいか分からない。",
    whyP1: "このサイトは彼らのために作られました。複雑な手続きも感情的な操作もなし。ただ直接的で誠実な寄付の場所。",
    whyP2: "お金は私——このサイトを作った人間——に直接届きます。それだけです。複雑すぎる世界の中のシンプルさ。",
    card1Title: "徹底的に正直",      card1Desc: "偽りの慈善団体はありません。お金は実在する人間に届きます。それは常に明確に、最初から述べられています。",
    card2Title: "純粋な寛大さ",       card2Desc: "報酬も定期購読も隠れた特典もなし——ただ、本当に意味をなしうる単純なサポートの行為。",
    card3Title: "小さなジェスチャー、リアルな影響", card3Desc: "世界中の人々が貢献することを選び、見知らぬ人からのわずかな寄付でも大きな意味を持てることを証明しています。",
    donateEyebrow: "さあ、動きましょう",
    donateH2a: "今日の", donateH2b: "あなたの贈り物は", donateH2c: "何ですか？",
    donateSub: "間違った金額はありません。待つべき完璧な理由もありません。大切なのは今日、あなたが寄付を選んだということです。",
    formTitle: "あなたの寄付", formSub: "金額を選ぶか、自由に入力してください",
    formName: "お名前またはニックネーム", formMsg: "メッセージ（任意）",
    formMsgPh: "なぜ寄付するのですか？（説明しなくても大丈夫です）",
    formAnon: "匿名で寄付する", formSecure: "🔒 Stripeで保護 · アカウント不要",
    cryptoEyebrow: "オンチェーン", cryptoH2: "暗号通貨で寄付しますか？",
    cryptoSub: "直接ウォレットに送金。仲介者なし、プラットフォーム手数料なし。",
    cryptoScan: "ウォレットアプリでスキャン", cryptoAccepts: "このアドレスが受け付ける通貨",
    cryptoWarning: "Base、Ethereum、Polygon、Arbitrum、BNBおよびすべてのEVMチェーンに対応。非EVMチェーン（Bitcoin、Solana）からの送金は永久的な損失を招きます。",
    transpEyebrow: "完全な透明性", transpH2: "お金はどこへ行くのか？",
    transpSub: "短い答え：私のところへ。それが具体的に何を意味するかを説明します。",
    t1Title: "レストランと楽しみ", t1Desc: "美食、良いワイン、良い思い出。充実した人生には時折の贅沢が必要——あなたがそれを支援してくれています。",
    t2Title: "次の大きなプロジェクト", t2Desc: "Tesla。本当に。一つ一つの寄付が、完全な電動の静寂の中で運転する夢に近づけてくれます。",
    t3Title: "夢：住宅ローン完済", t3Desc: "銀行なし、月々の支払いなし、本当に自分のものである屋根。夢を見てもいい——そしてどうやらあなたもそう思っているようですね。",
    donorsEyebrow: "寄付してくれた人たち", donorsH2: "最近の寄付者",
    donorsEmpty: "まだ寄付者はいません。", donorsEmptySub: "最初になりましょう——あなたの名前がここに表示されます。",
    manifestoQ: "この地球上には寛大な人々がいます。", manifestoEm: "このサイトは彼らのために作られました。", manifestoEnd: "一つの誠実な贈り物。ドラマなし。ただ、本当に良いことをしたという静かな満足感。",
    manifestoCite: "— 1-donation.com の作成者",
    footerDisclaimer: "寄付は自発的であり、見返りはありません",
    footerCopy: "© 2026 1-donation.com",
    thankYouTitle: "ありがとう。", thankYouP: "心から。あなたは今、インターネット上の見知らぬ人にお金を送り、何も求めませんでした。",
    thankYouEm: "それはある意味、美しいことです。", thankYouNote: "あなたの名前はまもなく寄付者セクションに表示されます。Stripeからメールで確認が送られました。",
    thankYouBtn: "閉じる — そして再度ありがとう",
    copyBtn: "コピー", copiedBtn: "コピー済 ✓", donateLoading: "Stripeへ移動中…", donateCta: "寄付する", donateNow: "今すぐ",
    amountSubs: ["コーヒー1杯","コーヒー2杯","良い食事","なぜダメ？","とても気前良い","あなた次第"],
    amountOther: "その他",
  },
  zh: {
    navWhy: "为何捐款？", navCrypto: "加密货币", navDonors: "捐款者", navDonate: "捐款",
    heroEyebrow: "献给那些不知该如何花钱的人",
    heroH1a: "一份礼物。", heroH1b: "一笔诚实的", heroH1c: "交易。",
    heroSub: "没有慈善机构。没有理由。只是一个在互联网上创建了一个让多余善意落地之处的人。",
    heroCta: "立即捐款", heroLearn: "了解更多 ↓",
    statDonors: "全球捐款者", statGiven: "捐款", statCountries: "个国家",
    whyEyebrow: "这个想法",
    whyH2a: "有些人就是", whyH2b: "不知道把慷慨", whyH2c: "送向何处。",
    whyP1: "这个网站就是为他们而建的。没有指定目的，没有情感操控，没有90%的管理费用。只是一个直接、诚实的捐款场所。",
    whyP2: "钱直接给我——这个建立了这个网站的人。这就是全部故事。在这个复杂的世界里，简单本身就是一种美德。",
    card1Title: "绝对诚实",      card1Desc: "没有慈善外壳。钱直接给一个真实的人。这一点始终明确地、直接地写在最前面。",
    card2Title: "纯粹的慷慨",     card2Desc: "没有奖励，没有订阅，没有隐藏福利——只是一个简单的支持行为，可以真正产生影响。",
    card3Title: "小小举动，真实影响", card3Desc: "来自世界各地的人选择贡献，证明即使是陌生人的小小捐款也能意味着强大的力量。",
    donateEyebrow: "现在行动",
    donateH2a: "今天你的", donateH2b: "这份礼物", donateH2c: "会是什么？",
    donateSub: "没有错误的金额。没有需要等待的完美理由。唯一重要的是，今天你选择了给予。",
    formTitle: "您的捐款", formSub: "选择金额或输入自定义金额",
    formName: "您的姓名或昵称", formMsg: "留言（可选）",
    formMsgPh: "为何捐款？（不解释也完全没问题）",
    formAnon: "匿名捐款", formSecure: "🔒 由Stripe保护 · 无需账户",
    cryptoEyebrow: "链上转账", cryptoH2: "更喜欢加密货币？",
    cryptoSub: "直接发送到我的钱包。无中间商，无平台费用——纯粹的链上转账。",
    cryptoScan: "用钱包扫描", cryptoAccepts: "此地址接受",
    cryptoWarning: "兼容Base、以太坊、Polygon、Arbitrum、BNB及所有EVM链。从非EVM链（比特币、Solana）发送将导致永久损失。",
    transpEyebrow: "完全透明", transpH2: "钱去哪了？",
    transpSub: "简短回答：给我。以下是这具体意味着什么。",
    t1Title: "餐厅与享乐", t1Desc: "美食、美酒、美好回忆。精彩的生活值得偶尔的奢华——而您正在帮助实现它。",
    t2Title: "我的下一个大项目", t2Desc: "一辆特斯拉。是的，真的。每一笔捐款都让我离在完全、电动、无愧的寂静中驾驶更近一步。",
    t3Title: "梦想：还清房贷", t3Desc: "完全拥有一个家。没有月供，没有银行，只是一个真正属于我的屋顶。人可以做梦——显然您也如此。",
    donorsEyebrow: "他们捐款了", donorsH2: "最近的捐款者",
    donorsEmpty: "还没有捐款者。", donorsEmptySub: "成为第一个——您的名字将显示在这里。",
    manifestoQ: "这个星球上有慷慨的人。", manifestoEm: "这个网站就是为他们建的。", manifestoEnd: "一份诚实的礼物。没有戏剧。只是做了一件真正有意义好事的安静满足感。",
    manifestoCite: "— 1-donation.com 背后的人",
    footerDisclaimer: "捐款是自愿的且无任何回报",
    footerCopy: "© 2026 1-donation.com",
    thankYouTitle: "谢谢你。", thankYouP: "真心的。你刚刚把钱送给了一个网上的陌生人，什么都没要求。",
    thankYouEm: "这在某种意义上很美。", thankYouNote: "您的名字很快将出现在捐款者区域。Stripe已向您的邮箱发送了确认邮件。",
    thankYouBtn: "关闭——再次感谢",
    copyBtn: "复制", copiedBtn: "已复制 ✓", donateLoading: "正在跳转到Stripe…", donateCta: "捐款", donateNow: "立即",
    amountSubs: ["一杯咖啡","两杯咖啡","一顿好饭","为什么不","非常慷慨","随您心意"],
    amountOther: "其他",
  },
  ar: {
    navWhy: "لماذا العطاء؟", navCrypto: "العملات الرقمية", navDonors: "المتبرعون", navDonate: "تبرّع",
    heroEyebrow: "لمن يملكون المال",
    heroH1a: "هدية واحدة.", heroH1b: "معاملة واحدة", heroH1c: "بكل صدق.",
    heroSub: "لا جمعية خيرية. لا قضية. لا تظاهر. مجرد شخص على الإنترنت بنى مكانًا يستقرّ فيه فائض الكرم.",
    heroCta: "قدّم تبرعًا", heroLearn: "اعرف المزيد ↓",
    statDonors: "متبرعون حول العالم", statGiven: "التبرعات", statCountries: "دول",
    whyEyebrow: "الفكرة",
    whyH2a: "بعض الناس ببساطة", whyH2b: "لا يعرفون إلى أين", whyH2c: "يوجّهون كرمهم.",
    whyP1: "هذا الموقع بُني من أجلهم. لا قضية محددة، ولا تلاعب بالمشاعر، ولا تكاليف إدارية تبتلع 90% من المبلغ. مجرد مكان مباشر وصادق للعطاء.",
    whyP2: "المال يذهب إليّ — أنا الشخص الذي بنى هذا الموقع. هذه هي القصة كلها. بساطةٌ في عالمٍ شديد التعقيد.",
    card1Title: "صراحة مطلقة",          card1Desc: "لا واجهة خيرية. المال يذهب إلى شخص حقيقي. وهذا مُعلَن بوضوح، منذ البداية، ودائمًا.",
    card2Title: "كرم خالص",             card2Desc: "لا مكافآت، ولا اشتراكات، ولا مزايا خفية — مجرد لفتة دعم بسيطة يمكن أن تُحدث فرقًا حقيقيًا.",
    card3Title: "لفتة صغيرة، وأثر حقيقي", card3Desc: "أناس من كل أنحاء العالم يختارون المساهمة، ليثبتوا أن تبرعًا صغيرًا من شخص غريب قد يحمل معنى عظيمًا.",
    donateEyebrow: "حان دورك",
    donateH2a: "ماذا ستكون", donateH2b: "هديتك", donateH2c: "اليوم؟",
    donateSub: "لا يوجد مبلغ خاطئ، ولا سبب مثالي للانتظار. كل ما يهم هو أنك اليوم اخترت أن تعطي.",
    formTitle: "تبرعك", formSub: "اختر مبلغًا أو أدخل المبلغ الذي تريده",
    formName: "اسمك أو اسم مستعار", formMsg: "رسالة (اختيارية)",
    formMsgPh: "لماذا تتبرع؟ (أو لا تشرح — لا بأس بذلك أيضًا)",
    formAnon: "تبرّع دون ذكر اسمك", formSecure: "🔒 مؤمَّن بواسطة Stripe · لا حاجة إلى حساب",
    cryptoEyebrow: "على البلوكتشين", cryptoH2: "تفضّل العملات الرقمية؟",
    cryptoSub: "أرسل مباشرة إلى محفظتي. بلا وسيط، وبلا رسوم منصّات — مجرد تحويل صافٍ على البلوكتشين.",
    cryptoScan: "امسح الرمز بتطبيق محفظتك", cryptoAccepts: "هذا العنوان يقبل",
    cryptoWarning: "متوافق مع Base، Ethereum، Polygon، Arbitrum، BNB وجميع شبكات EVM. الإرسال من شبكة غير متوافقة مع EVM (Bitcoin، Solana) سيؤدي إلى خسارة نهائية للأموال.",
    transpEyebrow: "شفافية كاملة", transpH2: "أين يذهب المال؟",
    transpSub: "الجواب المختصر: إليّ. وإليك ما يعنيه ذلك فعلًا.",
    t1Title: "مطاعم وملذّات",          t1Desc: "طعام طيب، ونبيذ جيد، وذكريات جميلة. الحياة التي تُعاش كما ينبغي تستحق شيئًا من الترف بين حين وآخر — وأنت تساهم في تمويله.",
    t2Title: "مشروعي الكبير القادم",   t2Desc: "سيارة Tesla. نعم، حقًا. كل تبرع يقرّبني خطوة صغيرة من القيادة في صمت تام، كهربائي، وبلا أي شعور بالذنب.",
    t3Title: "الحلم: سداد قرض منزلي",  t3Desc: "أن أمتلك بيتًا بالكامل. بلا أقساط شهرية، وبلا بنك، مجرد سقف هو ملكي حقًا. من حق المرء أن يحلم — ويبدو أنك تحلم أيضًا.",
    donorsEyebrow: "لقد أعطوا", donorsH2: "أحدث المتبرعين",
    donorsEmpty: "لا يوجد متبرعون بعد.", donorsEmptySub: "كن الأول — اسمك سيظهر هنا.",
    manifestoQ: "على هذا الكوكب أناسٌ كرماء.", manifestoEm: "ومن أجلهم بُني هذا المكان.", manifestoEnd: "هدية صادقة واحدة. بلا ضجيج. فقط ذلك الرضا الهادئ بأنك فعلت شيئًا طيبًا حقًا.",
    // ⁦ … ⁩ (invisible) keep "1-donation.com" left to right inside Arabic text
    manifestoCite: "— الشخص الذي يقف وراء ⁦1-donation.com⁩",
    footerDisclaimer: "التبرعات طوعية ودون أي مقابل",
    footerCopy: "© 2026 ⁦1-donation.com⁩",
    thankYouTitle: "شكرًا لك.", thankYouP: "من القلب. لقد أرسلت للتو مالًا إلى شخص غريب على الإنترنت ولم تطلب شيئًا في المقابل.",
    thankYouEm: "وفي ذلك شيء من الجمال.", thankYouNote: "سيظهر اسمك في قسم المتبرعين قريبًا. وقد أرسلت Stripe تأكيدًا إلى بريدك الإلكتروني.",
    thankYouBtn: "إغلاق — وشكرًا مرة أخرى",
    copyBtn: "نسخ", copiedBtn: "تم النسخ ✓", donateLoading: "جارٍ التحويل إلى Stripe…", donateCta: "تبرّع", donateNow: "الآن",
    amountSubs: ["فنجان قهوة","فنجانا قهوة","وجبة شهية","ولمَ لا","كرم كبير","حسب رغبتك"],
    amountOther: "مبلغ آخر",
  },
};

const LANGS = [
  { code: "en", label: "EN", flag: "https://flagcdn.com/24x18/gb.png" },
  { code: "fr", label: "FR", flag: "https://flagcdn.com/24x18/fr.png" },
  { code: "ru", label: "RU", flag: "https://flagcdn.com/24x18/ru.png" },
  { code: "ja", label: "JA", flag: "https://flagcdn.com/24x18/jp.png" },
  { code: "zh", label: "ZH", flag: "https://flagcdn.com/24x18/cn.png" },
  { code: "ar", label: "AR", flag: "https://flagcdn.com/24x18/sa.png" },
];

// First visit: the browser's language when the site has it. After that, the visitor's own choice.
function initialLang() {
  try {
    const saved = localStorage.getItem("lang");
    if (T[saved]) return saved;
  } catch { /* storage blocked (e.g. strict private mode): fall back to the browser language */ }
  const browser = (navigator.language || "").slice(0, 2).toLowerCase();
  return T[browser] ? browser : "en";
}

// ── Counter hook ──────────────────────────────────────────────────────────────
function useCounter(target, duration = 2000, start = false) {
  const [value, setValue] = useState(0);
  useEffect(() => {
    if (!start) return;
    if (!target) { setValue(0); return; }
    const t0 = performance.now();
    const tick = (now) => {
      const p = Math.min((now - t0) / duration, 1);
      const e = 1 - Math.pow(1 - p, 3);
      setValue(Math.floor(e * target));
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [start, target, duration]);
  return value;
}

// ── Crypto wallet ─────────────────────────────────────────────────────────────
const ETH_ADDRESS = "0xa31c5955cced15bb19f75e0c8ff2260654c943bd";
const ETH_ENS     = "virtufox.base.eth";
const QR_URL      = `https://api.qrserver.com/v1/create-qr-code/?data=ethereum:${ETH_ADDRESS}&size=180x180&bgcolor=FAF6EE&color=1A1410&margin=10`;
const CRYPTOS     = [
  { symbol: "ETH",  name: "Ethereum", color: "#627EEA" },
  { symbol: "USDC", name: "USD Coin", color: "#2775CA" },
  { symbol: "USDT", name: "Tether",   color: "#26A17B" },
  { symbol: "DAI",  name: "Dai",      color: "#F5AC37" },
];

// ── Donation stats ────────────────────────────────────────────────────────────
const EMPTY_STATS = { donors: 0, totalCents: 0, countries: 0 };

// Works with both backend versions: new { stats, recent } or the older full list.
function parseDonations(data) {
  if (data && data.stats) return { stats: data.stats, recent: data.recent || [] };
  if (Array.isArray(data)) {
    const codes = data.map(d => String(d.country || "").toUpperCase()).filter(c => c && c !== "UN");
    return {
      stats: {
        donors: data.length,
        totalCents: data.reduce((sum, d) => sum + (Number(d.amount) || 0), 0),
        countries: new Set(codes).size,
      },
      recent: data.slice(0, 12),
    };
  }
  return { stats: EMPTY_STATS, recent: [] };
}

// ── Cloudflare Turnstile hook ─────────────────────────────────────────────────
function useTurnstile(siteKey) {
  const containerRef = useRef(null);
  const widgetId     = useRef(null);
  const [token, setToken] = useState("");

  useEffect(() => {
    if (!siteKey || !containerRef.current) return;
    let cancelled = false;
    const render = () => {
      if (cancelled || !window.turnstile || widgetId.current !== null) return;
      widgetId.current = window.turnstile.render(containerRef.current, {
        sitekey: siteKey,
        appearance: "interaction-only",
        theme: "light",
        callback: setToken,
        "expired-callback": () => setToken(""),
        "error-callback": () => setToken(""),
      });
    };
    if (window.turnstile) render();
    else {
      let script = document.querySelector("script[data-turnstile]");
      if (!script) {
        script = document.createElement("script");
        script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
        script.async = true;
        script.dataset.turnstile = "1";
        document.head.appendChild(script);
      }
      script.addEventListener("load", render);
    }
    return () => { cancelled = true; };
  }, [siteKey]);

  // A token works only once: ask for a fresh one after each attempt.
  const reset = () => {
    setToken("");
    if (window.turnstile && widgetId.current !== null) window.turnstile.reset(widgetId.current);
  };

  return { containerRef, token, reset, enabled: Boolean(siteKey) };
}

// ── App ───────────────────────────────────────────────────────────────────────
export default function App() {
  const [lang, setLang]               = useState(initialLang);
  const [showLangs, setShowLangs]     = useState(false);
  const t                             = T[lang];

  const chooseLang = (code) => {
    setLang(code);
    try { localStorage.setItem("lang", code); } catch { /* storage blocked: the choice lasts for this visit only */ }
  };

  // Arabic reads right to left: tell the browser (direction) and App.css (Arabic fonts)
  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir  = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  const AMOUNTS = [
    { val: "5",      label: "€5",    sub: t.amountSubs[0] },
    { val: "10",     label: "€10",   sub: t.amountSubs[1] },
    { val: "25",     label: "€25",   sub: t.amountSubs[2] },
    { val: "50",     label: "€50",   sub: t.amountSubs[3] },
    { val: "100",    label: "€100",  sub: t.amountSubs[4] },
    { val: "custom", label: t.amountOther, sub: t.amountSubs[5] },
  ];

  const [formData, setFormData]         = useState({ name: "", message: "", anonymous: false, amount: "10" });
  const [selectedAmt, setSelectedAmt]   = useState("10");
  const [donors, setDonors]             = useState([]);
  const [stats, setStats]               = useState(EMPTY_STATS);
  const [loading, setLoading]           = useState(false);
  const captcha                         = useTurnstile(TURNSTILE_SITE_KEY);
  const [statsOn, setStatsOn]           = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);
  const [copied, setCopied]             = useState(false);
  const statsRef                        = useRef(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("success") === "true") {
      setShowThankYou(true);
      window.history.replaceState({}, "", window.location.pathname);
    }
  }, []);

  // Counters use the totals of ALL donations (not only the few shown on the page)
  const cDonors    = useCounter(stats.donors, 2000, statsOn);
  const cAmount    = useCounter(Math.round(stats.totalCents / 100), 2200, statsOn);
  const cCountries = useCounter(stats.countries, 1500, statsOn);
  // Western digits for amounts, even when the visitor's browser is set to Arabic
  const fmt        = (n) => n.toLocaleString(lang === "ar" ? "en-US" : undefined);

  useEffect(() => {
    fetch(`${API_BASE}/get-donations?view=summary`)
      .then(r => (r.ok ? r.json() : null))
      .then(d => {
        const { stats: s, recent } = parseDonations(d);
        setStats(s);
        setDonors(recent);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!statsRef.current) return;
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setStatsOn(true); }, { threshold: 0.3 });
    obs.observe(statsRef.current);
    return () => obs.disconnect();
  }, []);

  // The donor's country now comes from their card (read by the Stripe webhook),
  // so there is no extra call to a geolocation service before paying.
  const handleDonate = async () => {
    const amt = parseFloat(formData.amount);
    if (!amt || amt < 1) { alert("Minimum €1.00 please 🙏"); return; }
    setLoading(true);
    try {
      const name = formData.anonymous || !formData.name ? "Anonymous" : formData.name;
      const res  = await fetch(`${API_BASE}/create-checkout-session`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          amount: Math.round(amt * 100),
          name,
          message: formData.message || "",
          captchaToken: captcha.token,
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || "Something went wrong. Please try again.");

      if (data.url) { window.location.assign(data.url); return; }

      // Fallback for the previous backend version (returns only a session id)
      if (data.id) {
        const { loadStripe } = await import("@stripe/stripe-js");
        const stripe = await loadStripe(STRIPE_PK);
        const result = await stripe.redirectToCheckout({ sessionId: data.id });
        if (result.error) throw new Error(result.error.message);
        return;
      }
      throw new Error("Something went wrong. Please try again.");
    } catch (e) {
      console.error(e);
      alert(e.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
      if (captcha.enabled) captcha.reset();
    }
  };

  const selectAmt = (val) => {
    setSelectedAmt(val);
    if (val !== "custom") setFormData(f => ({ ...f, amount: val }));
  };

  const copyAddress = () => {
    navigator.clipboard.writeText(ETH_ADDRESS);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="font-sans bg-cream text-dark overflow-x-hidden" onClick={() => showLangs && setShowLangs(false)}>

      {/* NAV */}
      <nav className="fixed top-0 left-0 right-0 z-50 flex justify-between items-center px-6 md:px-16 py-4 bg-cream/95 backdrop-blur border-b border-gold/20">
        {/* LEFT: logo + language selector */}
        <div className="flex items-center gap-4">
          <a href="#" dir="ltr" className="font-serif text-xl md:text-2xl font-semibold text-dark no-underline">
            <span className="text-gold">1</span>-donation
          </a>
          <div className="relative" onClick={e => e.stopPropagation()}>
            <button
              onClick={() => setShowLangs(v => !v)}
              className="flex items-center gap-1.5 text-xs tracking-widest uppercase cursor-pointer border-none bg-transparent"
              style={{color:"#8A7055"}}
            >
              <img src={LANGS.find(l => l.code === lang)?.flag} alt={lang} style={{width:20,height:15,borderRadius:2,objectFit:"cover"}}/>
              <span>{LANGS.find(l => l.code === lang)?.label}</span>
              <span style={{fontSize:"0.6rem"}}>▾</span>
            </button>
            {showLangs && (
              <div className="absolute start-0 top-8 rounded-sm overflow-hidden shadow-lg z-50" style={{background:"#FAF6EE", border:"1px solid #F0E8D5", minWidth:100}}>
                {LANGS.map(l => (
                  <button key={l.code}
                    onClick={() => { chooseLang(l.code); setShowLangs(false); }}
                    className="w-full flex items-center gap-2 px-3 py-2 text-start text-xs cursor-pointer border-none transition-colors"
                    style={{background: lang === l.code ? "#F9F1DC" : "#FAF6EE", color: lang === l.code ? "#1A1410" : "#8A7055"}}
                  >
                    <img src={l.flag} alt={l.label} style={{width:20,height:15,borderRadius:2,objectFit:"cover"}}/>
                    <span>{l.label}</span>
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
        {/* RIGHT: nav links + donate */}
        <div className="flex gap-4 md:gap-6 items-center">
          <a href="#why"    className="hidden md:block text-xs tracking-widest uppercase text-warm hover:text-gold transition-colors no-underline">{t.navWhy}</a>
          <a href="#crypto" className="hidden md:block text-xs tracking-widest uppercase text-warm hover:text-gold transition-colors no-underline">{t.navCrypto}</a>
          <a href="#donors" className="hidden md:block text-xs tracking-widest uppercase text-warm hover:text-gold transition-colors no-underline">{t.navDonors}</a>
          <button
            onClick={() => document.getElementById("donate").scrollIntoView({ behavior: "smooth" })}
            className="text-xs tracking-widest uppercase px-4 py-2 rounded-sm cursor-pointer border-none"
            style={{background:"#1A1410", color:"#E8C97A"}}
          >
            {t.navDonate}
          </button>
        </div>
      </nav>

      {/* HERO */}
      <section className="min-h-screen bg-dark flex flex-col justify-center px-6 md:px-16 pt-24 pb-12 relative overflow-hidden">
        <div className="absolute inset-0 pointer-events-none" style={{background:"radial-gradient(ellipse 60% 80% at 80% 50%, rgba(201,168,76,0.11) 0%, transparent 70%)"}} />
        <div className="absolute start-6 md:start-16 top-1/2 -translate-y-1/2 w-px h-1/3 hidden md:block" style={{background:"linear-gradient(to bottom, transparent, #C9A84C, transparent)", opacity:0.3}} />
        <div className="relative max-w-2xl md:ms-20">
          <p className="text-xs tracking-widest uppercase mb-6 flex items-center gap-3" style={{color:"#C9A84C"}}>
            <span className="block w-8 h-px flex-shrink-0" style={{background:"#C9A84C"}} />
            {t.heroEyebrow}
          </p>
          <h1 className="font-serif font-light leading-tight mb-6" style={{fontSize:"clamp(2.5rem, 7vw, 5.5rem)", color:"#FAF6EE"}}>
            {t.heroH1a}<br />
            <em className="not-italic" style={{color:"#E8C97A"}}>{t.heroH1b}</em><br />
            {t.heroH1c}
          </h1>
          <p className="font-light leading-relaxed mb-8 max-w-md text-base md:text-lg" style={{color:"rgba(250,246,238,0.55)"}}>
            {t.heroSub}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 items-stretch sm:items-center">
            <button onClick={() => document.getElementById("donate").scrollIntoView({ behavior: "smooth" })}
              className="text-sm tracking-widest uppercase px-8 py-3 rounded-sm font-medium text-center cursor-pointer border-none"
              style={{background:"#C9A84C", color:"#1A1410"}}>{t.heroCta}</button>
            <button onClick={() => document.getElementById("why").scrollIntoView({ behavior: "smooth" })}
              className="text-sm tracking-widest uppercase cursor-pointer bg-transparent border-none text-start sm:text-center"
              style={{color:"rgba(250,246,238,0.35)"}}>{t.heroLearn}</button>
          </div>
        </div>
      </section>

      {/* STATS */}
      <div ref={statsRef} className="grid grid-cols-3" style={{background:"#2E2418", borderBottom:"1px solid rgba(201,168,76,0.15)"}}>
        {[
          { num: fmt(cDonors),       label: t.statDonors },
          { num: `€${fmt(cAmount)}`, label: t.statGiven },
          { num: cCountries || "—",  label: t.statCountries },
        ].map(({ num, label }, i) => (
          <div key={i} className="py-5 px-2 md:px-12 text-center" style={{borderInlineEnd: i < 2 ? "1px solid rgba(201,168,76,0.1)" : "none"}}>
            <span className="font-serif font-light block mb-1" style={{fontSize:"clamp(1.4rem, 4vw, 3rem)", color:"#E8C97A"}}>{num}</span>
            <span className="text-[9px] md:text-xs tracking-widest uppercase" style={{color:"rgba(250,246,238,0.3)"}}>{label}</span>
          </div>
        ))}
      </div>

      {/* WHY */}
      <section className="py-16 md:py-28 px-6 md:px-16 bg-cream" id="why">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-20 items-center">
          <div>
            <p className="text-xs tracking-widest uppercase mb-4 flex items-center gap-3" style={{color:"#C9A84C"}}>
              <span className="block w-6 h-px flex-shrink-0" style={{background:"#C9A84C"}} />{t.whyEyebrow}
            </p>
            <h2 className="font-serif font-light leading-snug mb-6" style={{fontSize:"clamp(1.8rem, 4vw, 3rem)", color:"#1A1410"}}>
              {t.whyH2a}<br />{t.whyH2b}<br />
              <em className="not-italic" style={{color:"#C9A84C"}}>{t.whyH2c}</em>
            </h2>
            <p className="font-light leading-relaxed mb-4 text-sm md:text-base" style={{color:"#5C4A2A"}}>{t.whyP1}</p>
            <p className="font-light leading-relaxed text-sm md:text-base" style={{color:"#5C4A2A"}}>{t.whyP2}</p>
          </div>
          <div className="flex flex-col gap-4">
            {/* Card 1 — rotating star */}
            <div className="bg-white p-5 rounded-sm flex gap-4 hover:shadow-md transition-shadow" style={{border:"1px solid #F0E8D5"}}>
              <div className="w-10 h-10 rounded-sm flex items-center justify-center flex-shrink-0" style={{background:"#F9F1DC"}}>
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{width:22,height:22}}>
                  <path className="icon-star" d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6L12 2z" stroke="#C9A84C" strokeWidth="1.5" strokeLinejoin="round" fill="none" style={{transformOrigin:"12px 12px"}}/>
                </svg>
              </div>
              <div>
                <div className="font-serif font-semibold mb-1 text-base md:text-lg" style={{color:"#1A1410"}}>{t.card1Title}</div>
                <div className="text-xs md:text-sm leading-relaxed" style={{color:"#8A7055"}}>{t.card1Desc}</div>
              </div>
            </div>
            {/* Card 2 — heartbeat */}
            <div className="bg-white p-5 rounded-sm flex gap-4 hover:shadow-md transition-shadow" style={{border:"1px solid #F0E8D5"}}>
              <div className="w-10 h-10 rounded-sm flex items-center justify-center flex-shrink-0" style={{background:"#F9F1DC"}}>
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{width:22,height:22}}>
                  <path className="icon-heart" d="M12 21C12 21 3 14.5 3 8.5a4.5 4.5 0 018.5-2 4.5 4.5 0 018.5 2C20 14.5 12 21 12 21z" stroke="#C9A84C" strokeWidth="1.5" strokeLinejoin="round" fill="none" style={{transformOrigin:"12px 12px"}}/>
                </svg>
              </div>
              <div>
                <div className="font-serif font-semibold mb-1 text-base md:text-lg" style={{color:"#1A1410"}}>{t.card2Title}</div>
                <div className="text-xs md:text-sm leading-relaxed" style={{color:"#8A7055"}}>{t.card2Desc}</div>
              </div>
            </div>
            {/* Card 3 — coin dropping into piggy bank */}
            <div className="bg-white p-5 rounded-sm flex gap-4 hover:shadow-md transition-shadow" style={{border:"1px solid #F0E8D5"}}>
              <div className="w-10 h-10 rounded-sm flex items-center justify-center flex-shrink-0" style={{background:"#F9F1DC"}}>
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{width:22,height:22}}>
                  {/* Coin — falls into slot */}
                  <ellipse className="icon-coin" cx="10" cy="3" rx="2.2" ry="1" stroke="#C9A84C" strokeWidth="1.3"/>
                  {/* Sparkles on impact */}
                  <line className="icon-spark icon-spark1" x1="7.5" y1="7.5" x2="6.5" y2="6"   stroke="#C9A84C" strokeWidth="1.1" strokeLinecap="round"/>
                  <line className="icon-spark icon-spark2" x1="10"  y1="7"   x2="10"  y2="5.5" stroke="#C9A84C" strokeWidth="1.1" strokeLinecap="round"/>
                  <line className="icon-spark icon-spark3" x1="12.5" y1="7.5" x2="13.5" y2="6" stroke="#C9A84C" strokeWidth="1.1" strokeLinecap="round"/>
                  {/* Piggy bank body */}
                  <ellipse cx="10" cy="14" rx="6.5" ry="5.5" stroke="#C9A84C" strokeWidth="1.4"/>
                  {/* Coin slot on top */}
                  <line x1="8.5" y1="8.5" x2="11.5" y2="8.5" stroke="#C9A84C" strokeWidth="1.4" strokeLinecap="round"/>
                  {/* Snout */}
                  <ellipse cx="16.5" cy="14.5" rx="1.8" ry="1.4" stroke="#C9A84C" strokeWidth="1.2"/>
                  <circle cx="16" cy="14.5" r="0.3" fill="#C9A84C"/>
                  <circle cx="17" cy="14.5" r="0.3" fill="#C9A84C"/>
                  {/* Eye */}
                  <circle cx="13.5" cy="11.5" r="0.5" fill="#C9A84C"/>
                  {/* Ear */}
                  <path d="M6 9.5 Q4.5 7.5 6.5 7 Q8 7 7.5 9" stroke="#C9A84C" strokeWidth="1.2" strokeLinecap="round" fill="none"/>
                  {/* Legs */}
                  <line x1="6.5"  y1="19" x2="6"   y2="22" stroke="#C9A84C" strokeWidth="1.4" strokeLinecap="round"/>
                  <line x1="9"    y1="19.5" x2="9" y2="22" stroke="#C9A84C" strokeWidth="1.4" strokeLinecap="round"/>
                  <line x1="11.5" y1="19.5" x2="11.5" y2="22" stroke="#C9A84C" strokeWidth="1.4" strokeLinecap="round"/>
                  <line x1="14"  y1="19" x2="14.5" y2="22" stroke="#C9A84C" strokeWidth="1.4" strokeLinecap="round"/>
                  {/* Tail */}
                  <path d="M3.5 12 Q2 11 2.5 13 Q3 15 2 15" stroke="#C9A84C" strokeWidth="1.2" strokeLinecap="round" fill="none"/>
                </svg>
              </div>
              <div>
                <div className="font-serif font-semibold mb-1 text-base md:text-lg" style={{color:"#1A1410"}}>{t.card3Title}</div>
                <div className="text-xs md:text-sm leading-relaxed" style={{color:"#8A7055"}}>{t.card3Desc}</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* DONATE */}
      <section className="py-16 md:py-28 px-6 md:px-16 relative overflow-hidden" id="donate" style={{background:"#1A1410"}}>
        <div className="absolute top-0 right-0 w-64 h-64 rounded-full pointer-events-none translate-x-1/2 -translate-y-1/2" style={{border:"1px solid rgba(201,168,76,0.07)"}} />
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-20 items-center">
          <div>
            <p className="text-xs tracking-widest uppercase mb-4 flex items-center gap-3" style={{color:"#C9A84C"}}>
              <span className="block w-6 h-px flex-shrink-0" style={{background:"#C9A84C"}} />{t.donateEyebrow}
            </p>
            <h2 className="font-serif font-light leading-snug mb-6" style={{fontSize:"clamp(1.8rem, 4vw, 3rem)", color:"#FAF6EE"}}>
              {t.donateH2a}<br />
              <em className="not-italic" style={{color:"#E8C97A"}}>{t.donateH2b}</em><br />
              {t.donateH2c}
            </h2>
            <p className="font-light leading-relaxed text-sm md:text-base" style={{color:"rgba(250,246,238,0.45)"}}>{t.donateSub}</p>
          </div>
          <div className="rounded-sm p-6 md:p-8" style={{background:"#FAF6EE"}}>
            <div className="font-serif text-xl md:text-2xl mb-1" style={{color:"#1A1410"}}>{t.formTitle}</div>
            <div className="text-xs mb-5" style={{color:"#8A7055"}}>{t.formSub}</div>
            <div className="grid grid-cols-3 gap-2 mb-3">
              {AMOUNTS.map(({ val, label, sub }) => (
                <button key={val} onClick={() => selectAmt(val)}
                  className="rounded-sm py-3 px-1 text-center transition-all cursor-pointer border"
                  style={{borderColor: selectedAmt === val ? "#C9A84C" : "#F0E8D5", background: selectedAmt === val ? "#F9F1DC" : "#FFFFFF", color: selectedAmt === val ? "#1A1410" : "#8A7055"}}>
                  <span className="font-serif text-lg block">{label}</span>
                  <span className="text-[9px] tracking-wider uppercase block mt-0.5" style={{color:"#8A7055"}}>{sub}</span>
                </button>
              ))}
            </div>
            <div dir="ltr" className="flex items-center gap-2 px-3 py-2 mb-4 rounded-sm" style={{border:"1px solid #F0E8D5", background:"#FFFFFF"}}>
              <span className="font-serif text-xl" style={{color:"#8A7055"}}>€</span>
              <input type="number" min="1" step="0.01" placeholder="Custom amount"
                className="border-none outline-none bg-transparent font-serif text-xl w-full font-light"
                style={{color:"#1A1410"}}
                value={formData.amount}
                onChange={e => { setFormData(f => ({ ...f, amount: e.target.value })); selectAmt("custom"); }} />
            </div>
            <div className="mb-3">
              <label className="block text-[10px] tracking-widest uppercase mb-1" style={{color:"#8A7055"}}>{t.formName}</label>
              <input type="text" placeholder="Marie Curie" disabled={formData.anonymous}
                className="w-full px-3 py-2 text-sm rounded-sm outline-none"
                style={{border:"1px solid #F0E8D5", background:"#FFFFFF", color:"#1A1410"}}
                value={formData.name} onChange={e => setFormData(f => ({ ...f, name: e.target.value }))} />
            </div>
            <div className="mb-3">
              <label className="block text-[10px] tracking-widest uppercase mb-1" style={{color:"#8A7055"}}>{t.formMsg}</label>
              <textarea placeholder={t.formMsgPh}
                className="w-full px-3 py-2 text-sm rounded-sm outline-none resize-none"
                style={{border:"1px solid #F0E8D5", background:"#FFFFFF", color:"#1A1410", height:64}}
                value={formData.message} onChange={e => setFormData(f => ({ ...f, message: e.target.value }))} />
            </div>
            <label className="flex items-center gap-2 mb-4 cursor-pointer">
              <input type="checkbox" checked={formData.anonymous}
                onChange={e => setFormData(f => ({ ...f, anonymous: e.target.checked }))} className="w-4 h-4" />
              <span className="text-xs" style={{color:"#8A7055"}}>{t.formAnon}</span>
            </label>
            {captcha.enabled && <div ref={captcha.containerRef} className="flex justify-center mb-3" />}
            <button onClick={handleDonate} disabled={loading || (captcha.enabled && !captcha.token)}
              className="w-full text-xs tracking-widest uppercase py-3 rounded-sm cursor-pointer border-none"
              style={{background:"#1A1410", color:"#E8C97A", opacity: loading || (captcha.enabled && !captcha.token) ? 0.6 : 1}}>
              {loading ? t.donateLoading : <>{t.donateCta} <bdi dir="ltr">€{parseFloat(formData.amount || 0).toFixed(2)}</bdi> — {t.donateNow}</>}
            </button>
            <p className="text-center text-[10px] mt-2" style={{color:"#8A7055"}}>{t.formSecure}</p>
          </div>
        </div>
      </section>

      {/* CRYPTO */}
      <section className="py-16 md:py-24 px-6 md:px-16 bg-cream" id="crypto">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10">
            <p className="text-xs tracking-widest uppercase mb-3 flex items-center justify-center gap-3" style={{color:"#C9A84C"}}>
              <span className="block w-6 h-px" style={{background:"#C9A84C"}} />{t.cryptoEyebrow}
              <span className="block w-6 h-px" style={{background:"#C9A84C"}} />
            </p>
            <h2 className="font-serif font-light mb-3" style={{fontSize:"clamp(1.8rem, 4vw, 3rem)", color:"#1A1410"}}>{t.cryptoH2}</h2>
            <p className="font-light text-sm md:text-base max-w-sm mx-auto" style={{color:"#8A7055"}}>{t.cryptoSub}</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center max-w-3xl mx-auto">
            <div className="flex flex-col items-center gap-4">
              <div dir="ltr" className="p-4 rounded-sm" style={{border:"1px solid rgba(201,168,76,0.25)", background:"#FAF6EE"}}>
                <img src={QR_URL} alt="ETH Wallet QR Code" className="w-44 h-44 block" onError={e => e.target.style.display="none"} />
              </div>
              <p className="text-xs tracking-widest uppercase text-center" style={{color:"#8A7055"}}>{t.cryptoScan}</p>
            </div>
            <div>
              <div dir="ltr" className="mb-5 rounded-sm overflow-hidden" style={{border:"1px solid #F0E8D5"}}>
                <div className="px-4 py-2 text-[10px] tracking-widest uppercase" style={{background:"#F0E8D5", color:"#8A7055"}}>Ethereum / Base address (EVM)</div>
                <div className="px-4 pt-3 pb-1 flex items-center gap-2">
                  <span className="text-sm font-serif" style={{color:"#C9A84C"}}>✦</span>
                  <span className="text-sm font-medium" style={{color:"#1A1410"}}>{ETH_ENS}</span>
                  <span className="text-[10px] px-1.5 py-0.5 rounded-sm" style={{background:"#F9F1DC", color:"#8A7055"}}>ENS</span>
                </div>
                <div className="px-4 py-3 flex items-center justify-between gap-3" style={{background:"#FFFFFF"}}>
                  <span className="text-xs font-mono break-all leading-relaxed" style={{color:"#8A7055"}}>{ETH_ADDRESS}</span>
                  <button onClick={copyAddress}
                    className="flex-shrink-0 text-[10px] tracking-widest uppercase px-3 py-1.5 rounded-sm cursor-pointer border-none"
                    style={{background: copied ? "#C9A84C" : "#1A1410", color: copied ? "#1A1410" : "#E8C97A", minWidth:64}}>
                    {copied ? t.copiedBtn : t.copyBtn}
                  </button>
                </div>
              </div>
              <p className="text-[10px] tracking-widest uppercase mb-3" style={{color:"#8A7055"}}>{t.cryptoAccepts}</p>
              <div className="flex flex-wrap gap-2 mb-5">
                {CRYPTOS.map(({ symbol, name, color }) => (
                  <div key={symbol} className="flex items-center gap-1.5 px-3 py-1.5 rounded-sm" style={{border:"1px solid #F0E8D5", background:"#FFFFFF"}}>
                    <span className="w-2 h-2 rounded-full flex-shrink-0" style={{background:color}} />
                    <span className="text-xs font-medium" style={{color:"#1A1410"}}>{symbol}</span>
                    <span className="text-[10px]" style={{color:"#8A7055"}}>{name}</span>
                  </div>
                ))}
                <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-sm" style={{border:"1px solid #F0E8D5", background:"#FFFFFF"}}>
                  <span dir="ltr" className="text-xs" style={{color:"#8A7055"}}>+ any ERC-20 token</span>
                </div>
              </div>
              <div className="rounded-sm px-4 py-3 flex gap-3 items-start" style={{background:"#F9F1DC", border:"1px solid rgba(201,168,76,0.2)"}}>
                <span style={{color:"#C9A84C", flexShrink:0}}>⚠</span>
                <p className="text-xs leading-relaxed" style={{color:"#8A7055"}}>{t.cryptoWarning}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TRANSPARENCY — with animated SVG icons */}
      <section className="py-16 md:py-24 px-6 md:px-16" style={{background:"#F0E8D5"}}>
        <div className="max-w-4xl mx-auto text-center mb-10">
          <p className="text-xs tracking-widest uppercase mb-3 flex items-center justify-center gap-3" style={{color:"#C9A84C"}}>
            <span className="block w-6 h-px" style={{background:"#C9A84C"}} />{t.transpEyebrow}
            <span className="block w-6 h-px" style={{background:"#C9A84C"}} />
          </p>
          <h2 className="font-serif font-light mb-3" style={{fontSize:"clamp(1.8rem, 4vw, 3rem)", color:"#1A1410"}}>{t.transpH2}</h2>
          <p className="font-light max-w-sm mx-auto text-sm md:text-base" style={{color:"#8A7055"}}>{t.transpSub}</p>
        </div>
        <div className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">

          {/* 1 — Coffee cup minimal + wavy steam */}
          <div className="bg-white rounded-sm p-6 text-center hover:-translate-y-1 transition-transform" style={{border:"1px solid rgba(201,168,76,0.12)"}}>
            <div className="mb-4" style={{height:56, display:"flex", alignItems:"center", justifyContent:"center"}}>
              <svg viewBox="0 0 44 50" fill="none" xmlns="http://www.w3.org/2000/svg" style={{width:40,height:50}}>
                {/* Wavy steam lines */}
                <path className="steam steam1" d="M15 16 Q13 12 15 8 Q17 4 15 1" stroke="#C9A84C" strokeWidth="1.3" strokeLinecap="round" fill="none"/>
                <path className="steam steam2" d="M22 16 Q20 12 22 8 Q24 4 22 1" stroke="#C9A84C" strokeWidth="1.3" strokeLinecap="round" fill="none"/>
                <path className="steam steam3" d="M29 16 Q27 12 29 8 Q31 4 29 1" stroke="#C9A84C" strokeWidth="1.3" strokeLinecap="round" fill="none"/>
                {/* Cup body */}
                <path d="M8 20h28l-3 14H11L8 20z" stroke="#C9A84C" strokeWidth="1.5" strokeLinejoin="round" fill="none"/>
                {/* Saucer */}
                <path d="M5 34h34" stroke="#C9A84C" strokeWidth="1.5" strokeLinecap="round"/>
                <path d="M8 37h28" stroke="#C9A84C" strokeWidth="1" strokeLinecap="round" opacity="0.4"/>
                {/* Handle */}
                <path d="M36 22c4 0 6 2 6 5s-2 5-6 5" stroke="#C9A84C" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
              </svg>
            </div>
            <div className="font-serif text-lg md:text-xl mb-2" style={{color:"#1A1410"}}>{t.t1Title}</div>
            <div className="text-xs md:text-sm leading-relaxed" style={{color:"#8A7055"}}>{t.t1Desc}</div>
          </div>

          {/* 2 — Tesla Game (always left to right; "contents" keeps it a direct grid item) */}
          <div dir="ltr" className="contents">
            <TeslaGame title={t.t2Title} desc={t.t2Desc} />
          </div>

          {/* 3 — House with sun arc animation */}
          <div className="bg-white rounded-sm p-6 text-center hover:-translate-y-1 transition-transform" style={{border:"1px solid rgba(201,168,76,0.12)"}}>
            <div className="mb-4" style={{height:56, display:"flex", alignItems:"center", justifyContent:"center"}}>
              <svg viewBox="0 0 48 56" fill="none" xmlns="http://www.w3.org/2000/svg" style={{width:44,height:56}}>
                {/* Sun — arcs from left roof to right roof */}
                <g className="sun" style={{transformOrigin:"24px 20px"}}>
                  <circle cx="24" cy="10" r="3.5" stroke="#C9A84C" strokeWidth="1.3" fill="none"/>
                  <line x1="24" y1="4.5" x2="24" y2="3"   stroke="#C9A84C" strokeWidth="1" strokeLinecap="round"/>
                  <line x1="29" y1="6"   x2="30" y2="4.5" stroke="#C9A84C" strokeWidth="1" strokeLinecap="round"/>
                  <line x1="19" y1="6"   x2="18" y2="4.5" stroke="#C9A84C" strokeWidth="1" strokeLinecap="round"/>
                  <line x1="31" y1="10"  x2="33" y2="10"  stroke="#C9A84C" strokeWidth="1" strokeLinecap="round"/>
                  <line x1="17" y1="10"  x2="15" y2="10"  stroke="#C9A84C" strokeWidth="1" strokeLinecap="round"/>
                </g>
                {/* House */}
                <path d="M6 32L24 18l18 14" stroke="#C9A84C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M10 28v18h10v-8h8v8h10V28" stroke="#C9A84C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="font-serif text-lg md:text-xl mb-2" style={{color:"#1A1410"}}>{t.t3Title}</div>
            <div className="text-xs md:text-sm leading-relaxed" style={{color:"#8A7055"}}>{t.t3Desc}</div>
          </div>

        </div>
      </section>

      {/* DONORS */}
      <section className="py-16 md:py-28 px-6 md:px-16" id="donors" style={{background:"#1A1410"}}>
        <div className="max-w-5xl mx-auto">
          <p className="text-xs tracking-widest uppercase mb-3 flex items-center justify-center gap-3" style={{color:"#C9A84C"}}>
            <span className="block w-6 h-px" style={{background:"#C9A84C"}} />{t.donorsEyebrow}
            <span className="block w-6 h-px" style={{background:"#C9A84C"}} />
          </p>
          <h2 className="font-serif font-light text-center mb-10" style={{fontSize:"clamp(1.8rem, 4vw, 3rem)", color:"#FAF6EE"}}>{t.donorsH2}</h2>
          {donors.length === 0 ? (
            <div className="text-center py-16 rounded-sm" style={{border:"1px solid rgba(201,168,76,0.1)"}}>
              <div className="font-serif text-5xl mb-4" style={{color:"rgba(201,168,76,0.2)"}}>∅</div>
              <p className="font-serif italic text-lg mb-2" style={{color:"rgba(250,246,238,0.3)"}}>{t.donorsEmpty}</p>
              <p className="text-xs tracking-widest uppercase" style={{color:"rgba(250,246,238,0.15)"}}>{t.donorsEmptySub}</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
              {donors.slice(0, 9).map((d, i) => (
                <div key={i} className="rounded-sm p-5" style={{border:"1px solid rgba(201,168,76,0.15)"}}>
                  <div className="flex justify-between items-center mb-3">
                    <span className="text-sm font-medium" style={{color:"#E8C97A"}}>{d.name}</span>
                    {d.country && d.country !== "UN" && d.country !== "un" && (
                      <img
                        src={`https://flagcdn.com/24x18/${d.country.toLowerCase()}.png`}
                        alt={d.country}
                        style={{width:24, height:18, borderRadius:2, objectFit:'cover'}}
                        onError={e => e.target.style.display='none'}
                      />
                  )}
                  </div>
                  {d.message && <p className="font-serif italic text-sm leading-relaxed" style={{color:"rgba(250,246,238,0.6)"}}>&ldquo;{d.message}&rdquo;</p>}
                  {d.amount  && <p className="text-[10px] tracking-wide mt-2" style={{color:"rgba(250,246,238,0.2)"}}>€{(d.amount/100).toFixed(2)}</p>}
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* MANIFESTO */}
      <section className="py-16 md:py-28 px-6 md:px-16 text-center" style={{background:"#F9F1DC", borderTop:"1px solid rgba(201,168,76,0.3)", borderBottom:"1px solid rgba(201,168,76,0.3)"}}>
        <blockquote className="font-serif font-light italic max-w-3xl mx-auto leading-snug" style={{fontSize:"clamp(1.4rem, 3.5vw, 2.8rem)", color:"#1A1410"}}>
          "{t.manifestoQ}{" "}
          <em className="not-italic" style={{color:"#C9A84C"}}>{t.manifestoEm}</em>{" "}
          {t.manifestoEnd}"
        </blockquote>
        <cite className="block mt-6 text-xs tracking-widest uppercase not-italic" style={{color:"#8A7055"}}>{t.manifestoCite}</cite>
      </section>

      {/* THANK YOU MODAL */}
      {showThankYou && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-6"
          style={{background:"rgba(26,20,16,0.92)", backdropFilter:"blur(8px)"}}
          onClick={() => setShowThankYou(false)}>
          <div className="relative max-w-md w-full rounded-sm p-10 text-center"
            style={{background:"#FAF6EE", border:"1px solid rgba(201,168,76,0.3)"}}
            onClick={e => e.stopPropagation()}>
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-16 h-px" style={{background:"linear-gradient(to right, transparent, #C9A84C, transparent)"}} />
            <div className="font-serif text-5xl mb-2" style={{color:"#C9A84C"}}>✦</div>
            <h2 className="font-serif font-light text-3xl mb-3" style={{color:"#1A1410"}}>{t.thankYouTitle}</h2>
            <p className="font-serif italic text-lg mb-6" style={{color:"#5C4A2A", lineHeight:1.7}}>
              {t.thankYouP}<br />
              <em style={{color:"#C9A84C"}}>{t.thankYouEm}</em>
            </p>
            <p className="text-xs leading-relaxed mb-8" style={{color:"#8A7055"}}>{t.thankYouNote}</p>
            <button onClick={() => setShowThankYou(false)}
              className="text-xs tracking-widest uppercase px-8 py-3 rounded-sm cursor-pointer border-none w-full"
              style={{background:"#1A1410", color:"#E8C97A"}}>
              {t.thankYouBtn}
            </button>
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-16 h-px" style={{background:"linear-gradient(to right, transparent, #C9A84C, transparent)"}} />
          </div>
        </div>
      )}

      {/* FOOTER */}
      <footer className="px-6 md:px-16 py-8 flex flex-col md:flex-row justify-between items-center gap-4 text-center md:text-start flex-wrap" style={{background:"#1A1410", borderTop:"1px solid rgba(201,168,76,0.1)"}}>
        <a href="#" dir="ltr" className="font-serif text-lg font-semibold no-underline" style={{color:"#FAF6EE"}}>
          <span style={{color:"#C9A84C"}}>1</span>-donation
        </a>
        <p className="text-[10px] tracking-widest uppercase" style={{color:"rgba(250,246,238,0.25)"}}>{t.footerDisclaimer}</p>
        <p className="text-[10px]" style={{color:"rgba(250,246,238,0.2)"}}>{t.footerCopy}</p>
      </footer>

    </div>
  );
}
